
/**
 *	LL:
 *
 *	Lokalisierungs-Daten
 *
 */

export const state = {
	lang: {}
}

export const mutations = {
	SET(state, langData) {
		state.lang = Object.assign( state.lang, langData );
	}
}

export const actions = {
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/LL.js